import React, { useRef, useEffect } from 'react'
import { Button, Input, Space } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

export default function ColumnSearch({ filterOptions, column }) {
  const inputEl: any = useRef(null)
  useEffect(() => {
    if (filterOptions.visible) {
      inputEl.current.focus()
    }
  }, [filterOptions.visible])

  return (
    <div style={{ padding: 8 }} data-testid="table_filter">
      <Input
        ref={inputEl}
        onPressEnter={filterOptions.confirm}
        value={filterOptions.selectedKeys[0]}
        placeholder={`Search ${column.title}`}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
        onChange={e =>
          filterOptions.setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
      />
      <Space>
        <Button
          size="small"
          icon={<SearchOutlined />}
          type="primary"
          onClick={() => filterOptions.confirm()}
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          size="small"
          style={{ width: 90 }}
          onClick={() => {
            filterOptions.clearFilters && filterOptions.clearFilters()
            filterOptions.confirm()
          }}
        >
          Reset
        </Button>
      </Space>
    </div>
  )
}
